module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="livechat-warning-wrapper">\r\n    <div class="livechat-warning-header">\r\n        <h3>Are you sure?</h3>\r\n    </div>\r\n    <p class="livechat-warning-text">\r\n        ' +
((__t = (decliningBoxText )) == null ? '' : __t) +
'\r\n    </p>\r\n    <div class="livechat-button-set">\r\n        <button class="livechat_consent_agree livechat_button livechat_button_large livechat_primary_button">\r\n            ' +
((__t = (acceptText )) == null ? '' : __t) +
'\r\n        </button>\r\n        <button class="livechat_consent_deny livechat_button livechat_button_text livechat_button_text_dull">\r\n            ' +
((__t = (rejectText )) == null ? '' : __t) +
'\r\n        </button>\r\n    </div>\r\n</div>';

}
return __p
}